/**
 * SharedProjectTrackList Component
 */

import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import { TabletS } from '../../atoms/mediaQueries';
import { projectTrackTitle } from '../Projects/projectView/ProjectTrackList';
import { SharedProjectTrackItem } from './SharedProjectTrackItem';

interface IOwnProps {
  license: ILicenseUsage[];
  tracks: GQL.IProjectTrackConnection;
}

const classes = new BEM('shared-project__track-list');

export const SharedProjectTrackList: React.SFC<IOwnProps> = (props) => (
  <TabletS>
    {(matches) => (
      <ul {...classes() }>
        {props.tracks.edges!.map((edge) => {
          const track = edge && edge.node;
          const title = track && projectTrackTitle(track!, edge && edge.version);
          return (
            <li key={edge.id} {...classes('item')}>
              <SharedProjectTrackItem
                title={title!}
                license={props.license}
                track={edge.node!}
                version={edge.version}
                size={matches ? 'medium' : 'small'}
              />
            </li>
          );
        })}
      </ul>
    )}
  </TabletS>
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/SharedProject/SharedProjectTrackList.tsx